import { Box, Card, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { RecommendedProduct } from 'src/api/woocommerce';
import { useUserContext } from 'src/auth/useUserContext';
import { useCurrentVisitContext } from 'src/sections/@dashboard/visit/hooks/useCurrentVisitContext';
import VisitProductsTab from '../../visit/components/VisitProductsTab';
import { translateKey } from 'src/locales/translate';


export default function ProfileProductsContent() {
  const { isProfessionalRole } = useUserContext();
  const { profileId = '' } = useParams();
  const { data } = useCurrentVisitContext();

  // Initialize with empty array as the visit might not have recommendedProducts yet
  const [recommendedProducts, setRecommendedProducts] = useState<
    RecommendedProduct[]
  >([]);

  // Create a mock visit object to pass to VisitProductsTab
  const mockVisit = {
    id: `profile-${profileId}`,
    recommendedProducts: recommendedProducts,
  };

  const handleProductsSelected = (products: RecommendedProduct[]) => {
    setRecommendedProducts(products);

    // Here you would typically save these recommendations to the profile or visit
  };

  if (!isProfessionalRole) {
    return (
      <Card sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1">{translateKey("hardcoded.tylko_specjalisci_moga_przegladac_i_zarzadzac_produktami")}</Typography>
      </Card>
    );
  }

  return (
    <Card sx={{ p: 3, height: '100%' }}>
      <Box sx={{ height: 'calc(100vh - 200px)' }}>
        <VisitProductsTab
          visit={mockVisit}
          onProductsSelected={handleProductsSelected}
        />
      </Box>
    </Card>
  );
}
